import { hasStrongAuthentication } from "@aix/aixinternal-shared"

type AuthenticationMethod = string | { method: string }

type AssuranceLevel = string | null

export type MfaGateDecision = {
  status: "ok" | "enroll" | "challenge"
  mfaRequired: boolean
}

/** A passkey assertion is sufficient for the app sign-in gate. */
export function getMfaGateDecision(
  currentLevel: AssuranceLevel,
  nextLevel: AssuranceLevel,
  authenticationMethods: readonly AuthenticationMethod[],
): MfaGateDecision {
  if (hasStrongAuthentication(currentLevel, authenticationMethods)) {
    return { status: "ok", mfaRequired: false }
  }
  if (nextLevel === "aal2") return { status: "challenge", mfaRequired: true }
  return { status: "enroll", mfaRequired: false }
}

/**
 * Supabase re-emits SIGNED_IN on every tab focus. Re-checking then remounts MfaGate,
 * whose enrollment replaces the factor the user just scanned, so only a new user re-checks.
 */
export function shouldRecheckMfaOnSignIn(checkedUserId: string | null, signedInUserId: string): boolean {
  return checkedUserId !== signedInUserId
}

/** UI-only check; the token API independently verifies the access token. */
export function hasStrongSession(jwt: string): boolean {
  try {
    const [, payload] = jwt.split(".")
    const claims = JSON.parse(atob(payload.replace(/-/g, "+").replace(/_/g, "/")))
    return hasStrongAuthentication(claims.aal, claims.amr)
  } catch {
    return false
  }
}
